define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var ManageDomainsBoxItemView = require("manager-views/ManageDomainsBoxItemView");

    var ManageDomainsBoxListView;

    ManageDomainsBoxListView = Marionette.CollectionView.extend({
        itemView : ManageDomainsBoxItemView
    });

    return ManageDomainsBoxListView;
});
